export const SELF_EMPLOYED_TYPE = 'selfEmployed';
